export default __webpack_public_path__ + "static/media/Phone.20a01843.png";